import { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';


const createApplier = (filter, actions) => (
  (items) => actions.reduce(
    (filteredItems, action) => filteredItems.filter((i) => action(i, filter)),
    items,
  )
);

const init = (location, defaultFilter) => {
  const updatedFilter = { ...defaultFilter, ...location.state };
  return updatedFilter;
};


const ListFilter = ({
  filterActions,
  items,
  render,
  default: defaultFilter,
  dismissExportAlert,
}) => {
  const location = useLocation();
  const history = useHistory();
  const [filter, setFilter] = useState(init(location, defaultFilter));

  const handleChange = (newFilter) => {
    if (dismissExportAlert) dismissExportAlert();
    const updatedFilter = { ...filter, ...newFilter };
    history.replace(location.pathname, updatedFilter);
    setFilter(updatedFilter);
  };

  const filtered = createApplier(filter, filterActions)(items);
  const renderProps = {
    filter,
    handleChange,
    items: filtered,
  };

  return (
    <>
      {render(renderProps)}
    </>
  );
};

ListFilter.defaultProps = {
  default: {},
};

ListFilter.propTypes = {
  filterActions: PropTypes.arrayOf(PropTypes.func).isRequired,
  items: PropTypes.array.isRequired,
  render: PropTypes.func.isRequired,
  default: PropTypes.object,
  dismissExportAlert: PropTypes.func,
};

export default ListFilter;
